<div ng-controller="generalController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>